export function relaxedParseDecimalNumber(
  number_string: string,
  number_thousands_sep = ".",
  number_dec_point = ",",
  max?: number,
) {
  if (number_string == null || number_string === "") {
    return 0;
  }

  const firstChar = (s: string) => (s && s.length > 0 ? s.charAt(0) : s);

  // Config holen und normalisieren
  number_thousands_sep = firstChar(number_thousands_sep) || ".";
  number_dec_point = firstChar(number_dec_point) || ",";

  // "-" darf nicht als Trenner verwendet werden, da es immer als Vorzeichen interpretiert wird
  if (number_thousands_sep === "-" || number_dec_point === "-") {
    throw new Error('"-" cannot be used as thousands separator or decimal point');
  }

  const maybeNegativSign = number_string.includes("-") ? "-" : "";

  // Set nutzen, um Duplikate zu vermeiden (falls Config auch Punkt/Komma ist)
  const allowedSeparators = new Set([number_thousands_sep, number_dec_point, ".", ","]);

  // Hilfsfunktion zum Escapen für Regex (wichtig für Punkt!)
  const escapeRegExp = (string: string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const separatorsPattern = Array.from(allowedSeparators)
    .map((s) => escapeRegExp(s))
    .join("");

  // Alles entfernen, was KEINE Ziffer und KEIN erlaubter Separator ist
  const regexPatternStr = "[^0-9" + separatorsPattern + "]";
  const allowedCharsRegex = new RegExp(regexPatternStr, "g");

  // Minus behandeln wir separat am Ende, daher hier entfernen
  let stripped = number_string.replace(allowedCharsRegex, "");

  if (stripped === "") return 0;

  // ---------------------------------------------------------
  // SCHRITT 2: Den entscheidenden Trenner finden (Pivot)
  // Wir suchen das allerletzte Zeichen, das keine Ziffer ist.
  // ---------------------------------------------------------

  let lastSepIndex = -1;
  let lastSepChar = "";

  // Rückwärts durch den String laufen
  for (let i = stripped.length - 1; i >= 0; i--) {
    const char = stripped[i];
    // Wenn das Zeichen keine Ziffer ist (0-9), ist es ein Separator
    if (char < "0" || char > "9") {
      lastSepIndex = i;
      lastSepChar = char;
      break; // Wir brauchen nur den letzten
    }
  }

  let isDecimalSeparator = false;

  if (lastSepIndex !== -1) {
    const suffixLength = stripped.length - 1 - lastSepIndex;

    // REGEL 0 (Die "max"-Regel):
    // Wenn max > 0 und max < 1000, dann kann die Zahl nie einen Tausendertrenner haben,
    // daher ist jeder Separator ein Dezimaltrenner
    if (max !== undefined && max > 0 && max < 1000) {
      isDecimalSeparator = true;
    }
    // REGEL 1 (Die "Relaxed"-Regel):
    else if (suffixLength !== 3) {
      isDecimalSeparator = true;
    }
    // REGEL 2 (Die Konflikt-Regel):
    else {
      if (lastSepChar === number_dec_point) {
        isDecimalSeparator = true;
      }
    }
  }

  // ---------------------------------------------------------
  // SCHRITT 3: Zusammensetzen
  // ---------------------------------------------------------

  let normalized = "";

  if (lastSepIndex === -1) {
    // Reine Ganzzahl
    normalized = stripped;
  } else {
    if (isDecimalSeparator) {
      const integerPartRaw = stripped.substring(0, lastSepIndex);
      const integerPartClean = integerPartRaw.replace(/[^0-9]/g, "");

      const decimalPartRaw = stripped.substring(lastSepIndex + 1);
      const decimalPartClean = decimalPartRaw.replace(/[^0-9]/g, "");

      normalized = integerPartClean + "." + decimalPartClean;
    } else {
      normalized = stripped.replace(/[^0-9]/g, "");
    }
  }

  const finalString = maybeNegativSign + normalized;
  const number = parseFloat(finalString);
  if (isNaN(number) || number === 0) return 0;
  return number;
}
